define('modules/start/products/sms/view',['require','exports','module','../base/view'],function(require, exports, module) {
    "use strict";

    var BaseProduct = require("../base/view");
    var Layout = BaseProduct.extend({
        loadData: function() {
        }
    });

    module.exports = Layout;
});

